module.exports = __webpack_public_path__ + "static/media/eye.33e43412.svg";